import { css, mediaQueries } from '@eti/styles';
import { vars, Stack, Inline, Checkbox, Text, textVariants } from '@etg/wings';
import { price as priceUtils } from '@eti/utils';
import { m as motion } from 'framer-motion';
import { ConnectedComboBox } from '@eti/form';
import { useTranslation } from '@eti/providers';
import TravelerDescription from '../../common/components/TravelerDescription';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const dropdownStyles = css`
  width: 312px;

  & > span {
    height: auto;
    margin-top: 0;
  }
`;
const checkboxLabelAndPriceStyles = css`
  display: flex;
  justify-content: space-between;
  padding-inline-start: 0.25rem;
`;
const wrapperStyles = css`
  border-top: ${vars.colors.divider} 1px solid;
  padding-block: 10px;
  padding-inline-end: 16px;

  @media ${mediaQueries.small.only} {
    padding: 16px;
  }

  &:last-child {
    border-bottom: ${vars.colors.divider} 1px solid;
  }
`;
const travelerDescriptionWrapperStyles = css`
  align-items: center;
  display: flex;
`;
const MealTravelerSelection = _ref => {
  let {
    traveler,
    productName,
    selectTraveler
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    choice,
    travelerType,
    travelerId,
    mealPreferences,
    name,
    isSelected
  } = traveler;
  const {
    value,
    priceRaw = 0
  } = choice !== null && choice !== void 0 ? choice : {};
  const isCheckboxDisabled = Boolean(!value) || priceRaw <= 0 || value === 'NO_OPTION';
  const hasPrice = Number.isInteger(priceRaw);
  const formattedPrice = hasPrice ? priceUtils.formatPrice(priceRaw) : priceRaw;
  const formatChoice = mealTraveler => {
    var _mealTraveler$choice;
    return (_mealTraveler$choice = mealTraveler === null || mealTraveler === void 0 ? void 0 : mealTraveler.choice) !== null && _mealTraveler$choice !== void 0 ? _mealTraveler$choice : '';
  };
  const normalizeChoice = selectedMealOption => {
    const {
      priceRaw: mealPrice = 0
    } = selectedMealOption;
    const mealTravelerInfo = {
      choice: selectedMealOption,
      selected: mealPrice > 0
    };
    return mealTravelerInfo;
  };
  return /*#__PURE__*/_jsxs(Stack, {
    className: wrapperStyles,
    "data-testid": `${productName}-traveler-${travelerId}`,
    spacing: 16,
    children: [/*#__PURE__*/_jsxs("div", {
      className: checkboxLabelAndPriceStyles,
      children: [/*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        spacing: 0,
        children: [/*#__PURE__*/_jsx(motion.div, {
          animate: {
            width: isCheckboxDisabled ? 0 : 'auto',
            marginInlineEnd: isCheckboxDisabled ? 0 : '8px'
          },
          className: css`
              overflow: hidden;
            `,
          transition: {
            type: 'tween'
          },
          children: /*#__PURE__*/_jsx(Checkbox, {
            checked: isSelected || false,
            "data-testid": `${productName}-checkbox-${travelerId}`,
            id: `${productName}-checkbox-${travelerId}`,
            onChange: () => selectTraveler(travelerId, !isSelected)
          })
        }), /*#__PURE__*/_jsx(Checkbox.Label, {
          htmlFor: `${productName}-checkbox-${travelerId}`,
          children: /*#__PURE__*/_jsx(TravelerDescription, {
            className: travelerDescriptionWrapperStyles,
            name: name,
            type: travelerType
          })
        })]
      }), /*#__PURE__*/_jsx(Text, {
        as: "p",
        "data-testid": `${productName}-traveler-${travelerId}-price`,
        variant: textVariants._16_BOLD,
        children: formattedPrice
      })]
    }), /*#__PURE__*/_jsx(ConnectedComboBox, {
      className: dropdownStyles,
      "data-testid": `${productName}-dropdown-${travelerId}`,
      format: formatChoice,
      label: t('Product.Meal.Dropdown.Label'),
      name: `${productName}.travelers.traveler-${travelerId}`,
      normalize: normalizeChoice,
      options: mealPreferences,
      placeholder: t('Product.Meal.Dropdown.Placeholder')
    })]
  }, name);
};
export default MealTravelerSelection;
//# sourceMappingURL=MealTravelerSelection.js.map